export class LoadFormError {
    static readonly type = "[Form] Load error";

    constructor(public payload: string) {}
}
